import { Grid } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  register("role");
  register("confirmed");
  setValue("role", 3);
  setValue("confirmed", true);

  const fields = [
    {
      label: "Nome",
      name: "firstName",
      required: true,
      type: "text",
      md: 6,
    },
    {
      label: "Cognome",
      name: "lastName",
      required: true,
      type: "text",
      md: 6,
    },
    {
      label: "Email",
      name: "email",
      required: true,
      type: "text",
      md: 4,
    },
    {
      label: "Username",
      name: "username",
      required: true,
      type: "text",
      md: 4,
    },
    {
      label: "Password temporanea",
      name: "password",
      required: true,
      type: "text",
      md: 4,
    },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            disabled={disabled}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
